// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:20
import { UnusedByType_abstract } from './../abstract/SagaBase/UnusedByType_abstract';
export class UnusedByType extends UnusedByType_abstract {}
